import { defineMessages } from "react-intl";

export const productAlertsMessages = defineMessages({
  title: {
    id: "ba2sM0",
    defaultMessage: "Product alerts",
    description: "product alerts page title",
  },
  subtitle: {
    id: "Rstkkl",
    defaultMessage:
      "Products customers asked to be told about when they are back in stock, most requested first.",
    description: "product alerts subtitle",
  },
  colProduct: {
    id: "hfLnTe",
    defaultMessage: "Product",
    description: "product alerts column",
  },
  colCount: {
    id: "acy/qs",
    defaultMessage: "Subscribers",
    description: "product alerts column",
  },
  colEmails: {
    id: "fzmtHQ",
    defaultMessage: "E-mails",
    description: "product alerts column",
  },
  removedProduct: {
    id: "GUriXV",
    defaultMessage: "Product no longer exists ({slug})",
    description: "product alerts deleted product",
  },
  copyEmails: {
    id: "iiiZZU",
    defaultMessage: "Copy e-mails",
    description: "product alerts action",
  },
  copied: {
    id: "ze5+Bg",
    defaultMessage: "E-mails copied",
    description: "product alerts notification",
  },
  showAll: {
    id: "i8IQYC",
    defaultMessage: "Show all {count}",
    description: "product alerts expand",
  },
  empty: {
    id: "zu63sK",
    defaultMessage: "No product alerts yet.",
    description: "product alerts empty list",
  },
});
